import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlobalMapComponent } from './global-map.component';

@NgModule({
    declarations: [
        GlobalMapComponent
    ],
    exports: [
        GlobalMapComponent
    ],
    imports: [
        CommonModule
    ]
})
export class GlobalMapModule { }
